import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface PreviewPanelProps {
  children: ReactNode;
  /** Override the outer sizing class. Defaults to a fixed 420 px sidebar. */
  className?: string;
  /** Heading content rendered in the top-left of the panel header. Defaults to "Preview". */
  heading?: ReactNode;
  /** Optional control rendered in the top-right of the panel header (e.g. a checkbox toggle). */
  headerAction?: ReactNode;
  /** Optional content rendered below the viewport (e.g. undo/redo controls). */
  footer?: ReactNode;
}

export const PreviewPanel = ({
  children,
  className = 'w-[420px] flex-shrink-0',
  heading = 'Preview',
  headerAction,
  footer,
}: PreviewPanelProps) => (
  <div className={cn(className, 'flex flex-col gap-2')}>
    <div className="flex items-center justify-between">
      <h3 className="text-sm font-semibold text-[#C3D82E] uppercase tracking-wide">{heading}</h3>
      {headerAction}
    </div>
    <div className="flex-1" style={{ minHeight: 400 }}>
      {children}
    </div>
    {footer && (
      <div className="flex items-center justify-center gap-2">
        {footer}
      </div>
    )}
  </div>
);
